module.exports = __webpack_public_path__ + "img/employee-3-old.be0081fe.jpg";